<cs-switch
  [label]="'display_in' | translate"
  [ngModel]="currencyWalletService.displayInFiat$ | async"
  (ngModelChange)="currencyWalletService.displayInFiat$.next($event)"
/>
<button class="onact96" type="button" (click)="onFiatSelectionBtnClick()">
  {{ currencyWalletService.inFiatConvertType$ | async }}
</button>
